<template>
  <lb-dialog
    data-testid="notification-dialog"
    v-model="localDialog"
    :loading="loading"
    :heading="featureData._id ? 'Update Notification' : 'Add Notification'"
    width="800"
    @input="onDialogInput"
  >
    <template v-slot:body>
      <div data-testid="notification-dialog__body">
        <div
          class="text-center grey--text title pa-6"
          v-if="dropdownNotifications?.length === 0"
          data-testid="notification-dialog__empty-state"
        >
          {{
            dropdownNotifications?.length === 0
              ? noFeatureMessage
              : ""
          }}
        </div>
        <v-row v-else data-testid="notification-dialog__form-row" class="ma-0">
          <v-col cols="6" class="my-0 py-1 d-flex flex-column " data-testid="notification-dialog__feature-section">
            <span class="font-weight-semibold mb-2" data-testid="notification-dialog__feature-label">Notification*</span>
            <lb-dropdown
              data-testid="notification-dialog__feature-dropdown"
              label=""
              v-model="localFeatureData.feature"
              :items="dropdownNotifications"
              itemtext="labelName"
              itemvalue="name"
              :key="dialogKey"
              roundedClass="rounded-lg"
              appendicon="mdi-chevron-down"
              class="notification-dropdown"
            />
          </v-col>
          <v-col v-if="activeTab === 0" cols="6" class="my-0 py-1 d-flex flex-column" data-testid="notification-dialog__scheduler-section">
            <span class="font-weight-semibold mb-2" data-testid="notification-dialog__scheduler-label">Scheduler</span>
            <lb-dropdown
              data-testid="notification-dialog__scheduler-dropdown"
              label="24"
              v-model="localFeatureData.scheduler"
              :items="[24]"
              :itemvalue="'24'"
              :disabled="true"
              roundedClass="rounded-lg"
              appendicon="mdi-chevron-down"
            />
          </v-col>
          <v-col v-if="activeTab === 0" cols="6" class="my-0 py-1 d-flex flex-column" data-testid="notification-dialog__coverage-section">
            <span class="font-weight-semibold mb-2" data-testid="notification-dialog__coverage-label">Coverage Months*</span>
            <lb-dropdown
              data-testid="notification-dialog__coverage-dropdown"
              label=""
              v-model="localFeatureData.periodCount"
              :items="latestPeriods"
              itemtext="name"
              itemvalue="value"
              roundedClass="rounded-lg"
              appendicon="mdi-chevron-down"
            />
          </v-col>
          <v-col cols="6" class="my-0 py-1 d-flex" data-testid="notification-dialog__status-section">
            <div class="d-flex align-center">
              <v-switch
                v-model="localFeatureData.status"
                :label="localFeatureData.status ? 'Enabled' : 'Disabled'"
                inset
                dense
                color="primary"
                hide-details
                class="mt-0 pt-0"
                data-testid="notification-dialog__status-switch"
              />
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-slot:actions v-if="dropdownNotifications?.length > 0">
      <v-spacer data-testid="notification-dialog__actions-spacer"></v-spacer>
      <v-btn
       
        class="ml-2"
        color="primary"
        @click="$emit('update', localFeatureData)"
        v-if="featureData._id"
        data-testid="notification-dialog__submit-btn--update"
      ><span>Update</span></v-btn>
      <v-btn
       
        class="ml-2"
        color="primary"
        @click="$emit('add', localFeatureData)"
        v-else
        data-testid="notification-dialog__submit-btn--add"
      >
        <span>Add</span>
      </v-btn>
    </template>
  </lb-dialog>
</template>

<script>
import { NOTIFICATIONS } from '../../utils/constants';
export default {
  props: {
    dialog: Boolean,
    loading: Boolean,
    featureData: Object,
    dropdownNotifications: Array,
    latestPeriods: Array,
    availableNotifications: Array,
    activeTab: Number,
  },
  data() {
    return {
      localDialog: this.dialog,
      localFeatureData: { ...this.featureData },
      noFeatureMessage: NOTIFICATIONS.MESSAGES.NO_FEATURE_AVAILABLE,
    };
  },
  computed: {
    /**
     * Generate a stable key for the dropdown that only changes when dialog opens
     * Uses featureData._id for edit mode, 'new' for create mode
     */
    dialogKey() {
      return this.featureData._id ? `edit-${this.featureData._id}` : 'new';
    },
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    /**
     * Sync localFeatureData when featureData prop changes (e.g., on edit)
     */
    featureData: {
      handler(newVal) {
        this.localFeatureData = { ...newVal };
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onDialogInput(val) {
      this.$emit("update:dialog", val);
    },
  },
};
</script>

<style lang="css" scoped>
</style>
